import { useTranslation } from 'react-i18next';
import { ManageUsersColumn } from './manageUsersColumns';

export interface ManageUsersTableHeadProps {
  columns: ManageUsersColumn[];
};

export const ManageUsersTableHead = (props: ManageUsersTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
};
